import { atom } from "recoil";
import { IEmpTitle, SelectedRowsToDelete } from "../types";

  export const addStateEmployeeTitle = atom({
    key: "addStateEmployeeTitle",
    default: false,
  });

  export const editStateEmployeeTitle = atom({
    key: "editStateEmployeeTitle",
    default: false,
  });
  
  export const employeeTitleSaving = atom({
    key: "emailDomainSaving",
    default: false,
  });

  export const employeeTitleStatus = atom({
    key: "employeeTitleStatus",
    default: true,
  });

  export const selectedRowsStateEmployeeTitle = atom({
    key: "selectedRowsStateEmpTitle",
    default: [],
  });

  export const selectedRowsEmpTitleToDelete = atom<SelectedRowsToDelete | undefined>({
    key: "selectedRowsEmailToDelete",
    default: undefined,
  });
  export const rowForEditEmployeeTitle = atom<IEmpTitle | undefined>(
    {
      key: "rowForEditEmployeeTitle",
      default: undefined,
    }
  );